export const homepageURL = "/";

export const blogListPageURL = "/blogs";

export const blogDetailsPageURL = "/blogs/:url";

export const testimonialsSectionURL ="/#testimonials";

export const contactusPageURL = "/contact";

export const loanPageURL = "/loan";

export const getQuotePageURL = "/get-quote";

export const getQuotePageJaipurURL = "/get-quote-in-jaipur";
export const getQuotesInJaipurURL = "/get-quotes-in-jaipur";

export const getQuotesInMumbaiURL = "/get-quotes-in-mumbai";
export const getQuotesInDelhiURL = "/get-quotes-in-delhi";
export const getQuotesInNoidaURL = "/get-quotes-in-noida";
export const getQuotesInFaridabadURL = "/get-quotes-in-faridabad";
export const getQuotesInGhaziabadURL = "/get-quotes-in-ghaziabad";
export const getQuotesInGurgaonURL = "/get-quotes-in-gurgaon";
export const getQuotesInAlwarURL = "/get-quotes-in-alwar";
export const getQuotesInPalwalURL = "/get-quotes-in-palwal";
export const getQuotesInPushkarURL = "/get-quotes-in-pushkar";

export const getQuotesForDestinationURL = "/get-quotes-for-destination";
export const getQuotesForDestinationRajasthanURL = "/get-quotes-for-destination-rajasthan";
export const getQuotesDestinationInJaipurURL = "/get-quotes-destination-in-jaipur";

export const perfectCorporateEventVenuesDelhiNcrURL =
  "/perfect-corporate-event-venues-in-delhi-ncr";
  export const perfectCorporateEventVenuesGurgaonNcrURL =
  "/perfect-corporate-event-venues-in-gurgaon";
  
export const weddingpectabutton = 'https://docs.google.com/forms/d/1zmbVCVptFniIbP8rBNQZXKA92gqJrtLdEANrjyqs4-U/viewform?edit_requested=true'